<template>
  <div>
    <b-row>
      <b-col
        cols="12"
        class="m-auto text-center mx-0"
      >
        <b-form-radio-group
          v-model="searchType"
          button-variant="outline-primary"
          :options="optionsRadio"
          buttons
          size="md"
          name="radios-btn-default"
        />
      </b-col>
      <b-col
        v-if="searchType === 'upgradePlan'"
        md="6"
        class="m-auto"
      >
        <b-card>
          <g-form @submit="upgradePlan">
            <b-row>
              <b-col md="6">
                <b-form-group>
                  <g-field
                    :value.sync="planUpgrade.tenantId"
                    :dir="isRight ? 'rtl' : 'ltr'"
                    label-text="domin"
                    field="select"
                    name="dealer"
                    rules="required"
                    :options="tenants"
                    label="domainName"
                    @input="() => {}"
                    @change="(v) => {
                      getSupscription(v.id);
                      companyName = v.id
                    }"
                  />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group>
                  <g-field
                    :value="companyName"
                    :dir="isRight ? 'rtl' : 'ltr'"
                    label-text="companyName"
                    field="select"
                    name="companyName"
                    :options="tenants"
                    label="name"
                    disabled
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row class="mb-50 text-center mx-0">
              <b-col
                md="6"
              ><p class="h2">
                {{ $t('startSubscraptionDate') }} :
              </p></b-col>
              <b-col
                md="6"
              ><span class="h4">{{ getDate(subscription.startDate) }}</span></b-col>
            </b-row>
            <b-row class="mb-1 text-center">
              <b-col
                md="6"
              ><p class="h2">
                {{ $t('endSubscraptionDate') }} :
              </p></b-col>
              <b-col
                md="6"
              ><span class="h4">{{ getDate(subscription.endDate) }}</span></b-col>
            </b-row>
            <hr>
            <div class="text-center">
              <b-row>
                <b-col
                  md="6"
                  class="m-auto mx-0"
                >
                  <b-form-group>
                    <g-field
                      :value="subscription.plans.id"
                      :dir="isRight ? 'rtl' : 'ltr'"
                      label-text="mainPlansCat"
                      field="select"
                      name="mainPlansCat"
                      :clearable="false"
                      :options="activePlans"
                      rules="required"
                      label="arabicName"
                      disabled
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  md="6"
                  class="m-auto"
                >
                  <b-form-group>
                    <g-field
                      :value.sync="planUpgrade.planId"
                      :dir="isRight ? 'rtl' : 'ltr'"
                      label-text="changedPlansCat"
                      field="select"
                      name="changedPlansCat"
                      :clearable="false"
                      :options="activePlans"
                      rules="required"
                      label="arabicName"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <hr>
                </b-col>
                <b-col
                  cols="12"
                  class="d-flex justify-content-center"
                >
                  <b-button
                    class="mx-1 btn-block"
                    type="submit"
                    variant="gradient-primary"
                    :disabled="!planUpgrade.planId"
                    data-action-type="save"
                  >
                    {{ $t("save") }}
                  </b-button>
                </b-col>
              </b-row>
            </div>
          </g-form>
        </b-card>
      </b-col>
      <b-col
        v-if="searchType === 'editPlan'"
        md="6"
        class="m-auto"
      >
        <b-card>
          <g-form @submit="updatePlan">
            <b-row class="mx-0">
              <b-col md="6">
                <b-form-group>
                  <g-field
                    :value="selectedItem.tenantId"
                    :dir="isRight ? 'rtl' : 'ltr'"
                    label-text="domin"
                    field="select"
                    name="tenantId"
                    rules="required"
                    :options="tenants"
                    label="domainName"
                    @change="(v) => {
                      companyName = v.id;
                      getSupscription(v.id);
                    }"
                  />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group>
                  <g-field
                    :value="companyName"
                    :dir="isRight ? 'rtl' : 'ltr'"
                    label-text="companyName"
                    field="select"
                    name="companyName"
                    :options="tenants"
                    label="name"
                    disabled
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row class="mb-50 text-center mx-0">
              <b-col
                md="6"
              ><p class="h2">
                {{ $t('startSubscraptionDate') }} :
              </p></b-col>
              <b-col
                md="6"
              ><span class="h4">{{ getDate(subscription.startDate) }}</span></b-col>
            </b-row>
            <b-row class="mb-1 text-center">
              <b-col
                md="6"
              ><p class="h2">
                {{ $t('endSubscraptionDate') }} :
              </p></b-col>
              <b-col
                md="6"
              ><span class="h4">{{ getDate(subscription.endDate) }}</span></b-col>
            </b-row>
            <b-row class="text-center">
              <b-col
                md="6"
                class="m-auto"
              >
                <b-form-group>
                  <g-field
                    :value="subscription.plans.id"
                    :dir="isRight ? 'rtl' : 'ltr'"
                    label-text="plansCat"
                    field="select"
                    name="plansCat"
                    :clearable="false"
                    :options="plans"
                    disabled
                    label="arabicName"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <hr>
            <b-row class="text-center mx-0">
              <!-- numberOfUsers -->
              <b-col
                md="5"
                class="m-auto"
              >
                <g-field
                  label-text="mainNumberOfUsers"
                  field="number"
                  rules="required|numbersNew"
                  readonly
                  name="mainNumberOfUsers"
                  :value="subscription.numberOfUsers"
                  type="number"
                />
              </b-col>
              <!-- numberOfUsers -->
              <b-col
                md="5"
                class="m-auto"
              >
                <g-field
                  label-text="numberOfUsers"
                  field="number"
                  rules="required|numbersNew"
                  :value.sync="selectedItem.numberOfUsers"
                  type="number"
                />
              </b-col>
              <b-col
                md="2"
                class="list-preview-button"
              >
                <b-button
                  variant="btn"
                  :class="['p-75 font-small-1', getUserAlert]"
                  @click="toggleInfo('numberOfUsers')"
                >
                  <feather-icon
                    id="branch-List-icon"
                    :icon="getUserIcon"
                    class="cursor-pointer mr-25"
                    size="10"
                  />
                  {{ getUserTitle }}
                </b-button>
              </b-col>
            </b-row>
            <transition name="fade">
              <div
                v-if="helper.numberOfUsers"
                class="border rounded bg-light mx-1"
              >
                <label class="table-title alert-secondary font-small-3">
                  <feather-icon
                    icon="UserIcon"
                    size="14"
                  />
                  {{ $t('usersListForTenant') }} </label>
                <g-table
                  :columns="usersTableColumns"
                  :items="users"
                  :createButton="{ visiable: false }"
                  :searchInput="{ visiable: false }"
                >
                  <template #actions="{ item }">
                    <div class="text-nowrap">
                      <b-button
                        v-b-tooltip.hover.top="item.isActive ? $t('deactivate') : $t('activate')"
                        v-permission="'deleteUsers'"
                        data-action-type="delete"
                        variant="flat-danger"
                        class="btn-icon"
                        size="sm"
                        @click="usersActivationHandling(item)"
                      >
                        <feather-icon
                          :id="`user-row-${item.id}-activation-icon`"
                          :icon="item.isActive ? 'XCircleIcon' : 'CheckCircleIcon'"
                          :stroke="item.isActive ? 'red' : 'green'"
                          class="cursor-pointer"
                        />
                      </b-button>
                    </div>
                  </template>
                </g-table>
              </div>
            </transition><br>
            <b-row class="text-center mx-0">
              <!-- numberOfBranches -->
              <b-col
                md="5"
                class="text-center"
              >
                <g-field
                  label-text="mainNumberOfBranches"
                  field="number"
                  rules="required|numbersNew"
                  readonly
                  name="mainBranchs"
                  :value="subscription.numberOfBranches"
                  type="number"
                />
              </b-col>
              <!-- numberOfBranches -->
              <b-col
                md="5"
                class="text-center"
              >
                <g-field
                  label-text="numberOfBranches"
                  field="number"
                  rules="required|numbersNew"
                  :value.sync="selectedItem.numberOfBranches"
                  type="number"
                />
              </b-col>
              <b-col
                md="2"
                class="list-preview-button"
              >
                <b-button
                  variant="btn"
                  :class="['p-75 font-small-1', getBranchAlert]"
                  @click="toggleInfo('numberOfBranches')"
                >
                  <feather-icon
                    id="branch-List-icon"
                    :icon="getBranchIcon"
                    class="cursor-pointer mr-25"
                    size="10"
                  />
                  {{ getBranchTitle }}
                </b-button>
              </b-col>
            </b-row>
            <transition name="fade">
              <div
                v-if="helper.numberOfBranches"
                class="border rounded bg-light mx-1"
              >
                <label
                  class="table-title alert-secondary font-small-3"
                >
                  <feather-icon
                    icon="GitBranchIcon"
                    size="14"
                  />
                  {{ $t('branchesListForTenant') }} </label>
                <g-table
                  :columns="branchesTableColumns"
                  :items="branches"
                  :createButton="{ visiable: false }"
                  :searchInput="{ visiable: false }"
                >
                  <template #actions="{ item }">
                    <div class="text-nowrap">
                      <b-button
                        v-b-tooltip.hover.top="item.isActive ? $t('deactivate') : $t('activate')"
                        v-permission=" 'deleteBranches'"
                        data-action-type="delete"
                        variant="flat-danger"
                        class="btn-icon"
                        size="sm"
                        @click="branchesActivationHandling(item)"
                      >
                        <feather-icon
                          :id="`user-row-${item.id}-activation-icon`"
                          :icon="item.isActive ? 'XCircleIcon' : 'CheckCircleIcon'"
                          :stroke="item.isActive ? 'red' : 'green'"
                          class="cursor-pointer"
                        />
                      </b-button>
                    </div>
                  </template>
                </g-table>
              </div>
            </transition><br>
            <b-row class="mx-0">
              <!-- numberOfStudents -->
              <b-col
                md="5"
                class="text-center"
              >
                <g-field
                  label-text="mainNumberOfStudents"
                  field="number"
                  rules="required|numbersNew"
                  readonly
                  name="mainStudents"
                  :value="subscription.numberOfStudents"
                  type="number"
                />
              </b-col>
              <!-- numberOfStudents -->
              <b-col
                md="5"
                class="text-center"
              >
                <g-field
                  label-text="numberOfStudents"
                  field="number"
                  rules="required|numbersNew"
                  :value.sync="selectedItem.numberOfStudents"
                  type="number"
                />
              </b-col>
            </b-row>
            <b-row class="mx-0 mt-1">
              <b-col
                cols="12"
                class="d-flex justify-content-center"
              >
                <b-button
                  class="btn-block"
                  type="submit"
                  :disabled="!selectedItem.numberOfUsers || !selectedItem.numberOfBranches || !subscription.plans.id"
                  variant="gradient-primary"
                  data-action-type="save"
                >
                  {{ $t("save") }}
                </b-button>
              </b-col>
            </b-row>
          </g-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { plans } from '@/libs/acl/Lookups';
import GTable from '@/pages/Shared/Table.vue';

export default {
  components: {
    GTable,
  },
  data() {
    return {
      selectedItem: {
        palnId: '',
        numberOfUsers: 0,
        numberOfBranches: 0,
        numberOfStudents: 0,
        companyName: null
      },
      planUpgrade: {
        planId: null,
        tenantId: null
      },
      plans,
      mainPlans: [],
      activePlans: [],
      tenants: [],
      users: [],
      branches: [],
      searchType: 'editPlan',
      subscription: {
        plans: {
            id: null
        }
      },
      helper: {
        numberOfUsers: 0,
        numberOfBranches: 0
      },
      profile: JSON.parse(window.localStorage.getItem('@USER_PROFILE'))
    };
  },
  computed: {
    optionsRadio() {
      return [
        { text: this.$t('editPlan'), value: 'editPlan', disabled: this.isEditPlanDisabled },
        { text: this.$t('updatePlan'), value: 'upgradePlan', disabled: this.isUpgardePlanDisabled },
      ];
    },
    isEditPlanDisabled() {
      return this.profile.isAdmin ? false : !this.profile.permissions.some(id => id === 'editPlan')
    },
    isUpgardePlanDisabled() {
      return this.profile.isAdmin ? false : !this.profile.permissions.some(id => id === 'upgradePlan')
    },
    usersTableColumns() {
      return [
        {
          key: 'code',
          label: this.$t('code'),
        },
        {
          key: this.isRight ? 'arabicName' : 'englishName',
          label: this.$t('fullName'),
          sortable: true,
          tdClass: 'align-content-center',
        },
        {
          key: 'isAdmin',
          label: this.$t('userNature'),
          sortable: true,
          formatter: (key, value, item) => {
            if (item.isAdmin) return `<span class="badge alert-warning p-50">${this.$t('anAdmin')}</span>`;
            return `<span class="badge alert-primary p-50">${this.$t('aUser')}</span>`;
          },
        },
        {
          key: 'isActive',
          label: this.$t('status'),
          sortable: true,
          formatter: (key, value, item) => {
            if (item.isActive) return `<span class="badge badge-light-success p-50">${this.$t('activated')}</span>`;
            return `<span class="badge badge-light-danger p-50">${this.$t('notActivated')}</span>`;
          },
        },
        {
          key: 'actions',
        },
      ];
    },
    branchesTableColumns() {
      return [
        {
          key: 'code',
          label: this.$t('code'),
        },
        {
          key: this.isRight ? 'arabicName' : 'englishName',
          label: this.$t('fullName'),
          sortable: true,
          tdClass: 'align-content-center',
        },
        {
          key: 'isActive',
          label: this.$t('status'),
          sortable: true,
          formatter: (key, value, item) => {
            if (item.isActive) return `<span class="badge badge-light-success p-50">${this.$t('activated')}</span>`;
            return `<span class="badge badge-light-danger p-50">${this.$t('notActivated')}</span>`;
          },
        },
        {
          key: 'actions',
        },
      ];
    },
    getUserIcon() {
      return this.helper.numberOfUsers > 0 ? 'EyeOffIcon' : 'EyeIcon'
    },
    getUserTitle() {
      return this.helper.numberOfUsers > 0 ? this.$t('hideList') : this.$t('viewList')
    },
    getUserAlert() {
      return this.helper.numberOfUsers > 0 ? 'alert-danger' : 'alert-primary'
    },
    getBranchIcon() {
      return this.helper.numberOfBranches > 0 ? 'EyeOffIcon' : 'EyeIcon'
    },
    getBranchTitle() {
      return this.helper.numberOfBranches > 0 ? this.$t('hideList') : this.$t('viewList')
    },
    getBranchAlert() {
      return this.helper.numberOfBranches > 0 ? 'alert-danger' : 'alert-primary'
    }
  },
  mounted() {
   // this.activePlans = JSON.parse(JSON.stringify(this.plans))
    this.getTeanets()
    this.getPlans()
  },
  methods: {
    getTeanets() {
      this.get({ url: 'Tenants' }).then((data) => {
        this.tenants = data;
      });
    },
    getPlans() {
    this.get({ url: 'Plans' }).then((data) => {
      this.activePlans = data;
      });
    },
    getBranches(id) {
      this.helper.numberOfBranches = 0;
      this.get({ url: `Tenants/${id}/branch` }).then((data) => {
        this.branches = data;
      });
    },
    getUsers(id) {
      this.helper.numberOfUsers = 0;
      this.get({ url: `Tenants/${id}/user` }).then((data) => {
        this.users = data;
      });
    },
    getSupscription(_id) {
    // this.activePlans = JSON.parse(JSON.stringify(this.plans));
      this.get({ url: `Subscriptions?tenantId=${_id}` }).then((data) => {
        // this.subscription = data;
        // if (data.plans.id === 3) {
        //     this.activePlans.forEach(element => {
        //         if (element.id === 2) {
        //             const indx = this.activePlans.indexOf(element);
        //             this.activePlans.splice(indx, 1);
        //         }
        //     });
        //     this.activePlans.forEach(element => {
        //         if (element.id === 1) {
        //             const indx = this.activePlans.indexOf(element);
        //             this.activePlans.splice(indx, 1);
        //         }
        //     });
        // } else if (data.plans.id === 2) {
        //     this.activePlans.forEach(element => {
        //         if (element.id === 1) {
        //             const indx = this.activePlans.indexOf(element);
        //             this.activePlans.splice(indx, 1);
        //         }
        //     });
        // } else if (data.plans.id === 1) {
        //     this.activePlans = this.plans
        // }
        this.subscription = JSON.parse(JSON.stringify(data))
        this.selectedItem = data;
        this.getBranches(_id);
        this.getUsers(_id);
      });
    },
    upgradePlan() {
      this.update({
        url: `Subscriptions/Upgrade?tenantId=${this.planUpgrade.tenantId}&planId=${this.planUpgrade.planId}`
      }).then((data) => {
        this.doneAlert({
          text: this.$t('savedSuccessfully'),
        });
        window.location.reload();
      });
    },
    updatePlan() {
      this.update({
        url: 'Subscriptions',
        data: this.selectedItem,
      }).then((data) => {
        this.doneAlert({
          text: this.$t('savedSuccessfully'),
        });
        window.location.reload();
      });
    },
    toggleInfo(field) {
      this.$set(this.helper, field, !this.helper[field]);
    },
    handleUserActivation(user) {
      this.get({ url: `Tenants/user-ChangeStatus?userId=${user.id}&isActive=${!user.isActive}` }).then(() => {
        const message = user.isActive ? 'deactivateDoneSuccessfully' : 'activateDoneSuccessfully';
        this.doneAlert({ text: this.$t(message) });
        this.getUsers(this.selectedItem.tenantId);
        this.helper.numberOfUsers = this.users ? this.users.length : 0;
      });
    },
    usersActivationHandling(user) {
      if (user.isAdmin && user.isActive) {
        this.confirmAction({
          title: this.$t('deactivateUser'),
          text: this.$t('userisAdminAreYouSureDeactivate'),
          confirmText: this.$t('yesDeactivate')
        },
        () => {
          this.handleUserActivation(user);
        });
      } else {
        this.handleUserActivation(user);
      }
    },
    branchesActivationHandling(branch) {
      this.get({ url: `Tenants/branch-ChangeStatus?branchId=${branch.id}&isActive=${!branch.isActive}` }).then(() => {
        const message = branch.isActive ? 'deactivateDoneSuccessfully' : 'activateDoneSuccessfully';
        this.doneAlert({ text: this.$t(message) });
        this.getBranches(this.selectedItem.tenantId);
        this.helper.numberOfBranches = this.branches ? this.branches.length : 0;
      });
    },
  },
  };
</script>

<style scoped>
.list-preview-button {
  margin-top: 2em;
}

.table-title {
  display: block;
  padding: 0.75em;
  margin-bottom: -3.4em;
  border-radius: 5px;
  letter-spacing: 2px;
}
</style>
